import React from 'react';
import './btnStyle.scss';

const RoundButton = ({ label, onClick, disabled, iconClass }) => {
    return (
        <button
          className="btn btn-round col-md-12"
          onClick={onClick}
          disabled={disabled}
        >
          <div className="btn-content d-flex align-items-center justify-content-center w-100">
            <span className=" col-md-10 text-center">{label}</span>
            {iconClass && <i className={`bi ${iconClass} btn-icon ms-2`}></i>}
          </div>
        </button>
      );
};

export default RoundButton;
